import { Component, Input, OnInit } from '@angular/core';
import { DynamicBrandingService } from '@boxx/dynamic-branding';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-kpi-item',
  templateUrl: './kpi-item.component.html',
  styleUrls: ['./kpi-item.component.scss'],
})
export class KpiItemComponent implements OnInit {
  @Input() className: string;
  @Input() label: string;
  @Input() value: number;
  bgBrand: string;

  constructor(private dBrandingService: DynamicBrandingService) {}

  ngOnInit() {
    this.dBrandingService.themeChange$.subscribe(brandName => {
      this.bgBrand = 'special-'+brandName.toLowerCase(); 
    });
  }
}
